// src/components/NovuUI.tsx
import { NovuUI as NovuUIClass } from "@novu/js/ui";
import { useEffect, useState } from "react";
import { NovuUIProvider } from "../context/NovuUIContext.js";
import { useDataRef } from "../hooks/internal/useDataRef.js";
import { jsx } from "react/jsx-runtime";
var NovuUI = ({ options, novu, children }) => {
  const optionsRef = useDataRef({ ...options, novu });
  const [novuUI, setNovuUI] = useState();
  useEffect(() => {
    const novu2 = new NovuUIClass(optionsRef.current);
    setNovuUI(novu2);
    return () => {
      novu2.unmount();
    };
  }, []);
  useEffect(() => {
    if (!novuUI) {
      return;
    }
    novuUI.updateAppearance(options.appearance);
    novuUI.updateLocalization(options.localization);
    novuUI.updateTabs(options.tabs);
    novuUI.updateOptions(options.options);
    novuUI.updateRouterPush(options.routerPush);
  }, [options]);
  if (!novuUI) {
    return null;
  }
  return /* @__PURE__ */ jsx(NovuUIProvider, { value: { novuUI }, children });
};
export {
  NovuUI
};
//# sourceMappingURL=NovuUI.js.map